function addTagIds(tagCollection = [], tagIds) {
    return [...tagCollection, ...tagIds];
}
export default addTagIds;
//# sourceMappingURL=addTagsIds.js.map